import React from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { Box, Button, Checkbox, FormControlLabel, TextField } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

interface EndpointNodeGroupVrrpProps {
  onSubmit: () => void;
  endpointNodeGroup: string;
  endpointVrrpEnabled: boolean;
  endpointVrrp?: string;
}
export const EndpointNodeGroupVrrp = ({
  onSubmit,
  endpointNodeGroup,
  endpointVrrpEnabled = false,
  endpointVrrp,
}: EndpointNodeGroupVrrpProps) => {
  const api = useApi();
  const [enabled, setEnabled] = React.useState(endpointVrrpEnabled);
  const [ip, setIp] = React.useState(endpointVrrp);

  const enDhcpPost = useMutation(api.configureVrrpApiV1ConfigureVrrpPost, {
    onSuccess() {
      toast.success('Endpoint group VRRP configuration updated successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    enDhcpPost.mutate({
      node_group_id: endpointNodeGroup,
      enabled,
      virtual_ip: ip,
    });
  };

  return (
    <Box pt={2}>
      <FormControlLabel
        control={<Checkbox checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />}
        label="Enable VRRP Function"
        sx={{ mb: 4 }}
      />

      <TextField
        fullWidth
        label="VRRP IP"
        variant="outlined"
        value={ip}
        onChange={(e) => setIp(e.target.value)}
        placeholder="VRRP IP, example: 192.168.67.9"
        disabled={!enabled}
        autoFocus
      />

      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Submit
        </Button>
      </Box>
    </Box>
  );
};
